/* JS to add click event listeners to the main menu `menu--main.html.twig` */
const collapseAllOtherExpandedDropdowns = (excludeLink) => {
    // collapse all dropdowns then toggle target
    const expandedDropdowns = document.querySelectorAll('.js-expanded');
    expandedDropdowns.forEach(
      (expandedLink) => expandedLink !== excludeLink && expandedLink.classList.remove('focus'),
    );
  };

  
  const closeSubjectsNav = () => {
    const subjectsNavItem01 = document.getElementsByClassName('subjects-nav-item-0-1')[0];
    if (subjectsNavItem01) {
      subjectsNavItem01.classList.remove('focus');
    }
  
    const subjectsNavCallout = document.getElementById('subjects-nav-callout');
    if (subjectsNavCallout) {
      subjectsNavCallout.classList.remove('focus');
    }
  
    const subjectsNavLearningAreas = document.getElementsByClassName('subjects-nav__learning-areas')[0];
    if (subjectsNavLearningAreas) {
      subjectsNavLearningAreas.classList.remove('focus');
    }
  };
  
  const toggleMobileMainNav = () => {
    if (document.getElementById('header') && document.getElementById('main-nav-burger')) {
        const header = document.getElementById('header');
        const burger = document.getElementById('main-nav-burger');
        const mobileBurger = document.getElementById('mobile-main-nav-burger');

        header.classList.toggle("header--open");
        burger.classList.toggle("main-nav-burger--open");
        burger.classList.toggle("main-nav-burger--closed");
        mobileBurger.classList.toggle("main-nav-burger--open");
        mobileBurger.classList.toggle("main-nav-burger--closed");

        const brand = document.querySelector('.header__brand');
        if(brand) {
            brand.classList.toggle('header__brand--open');
            brand.classList.toggle('header__brand--closed');
        }

        const navigation = document.querySelector('.header__navigation');
        if(navigation) {
            navigation.classList.toggle('header__navigation--open');
            navigation.classList.toggle('header__navigation--closed');
        }
        
        const language = document.querySelector('.header__language');
        if(language) {
            language.classList.toggle('header__language--open');
            language.classList.toggle('header__language--closed');
        }
        
        const button = document.querySelector('.header__button');
        if(button) {
            button.classList.toggle('header__button--open');
            button.classList.toggle('header__button--closed');
        }

        /** Put no-scroll on the body */
        document.querySelector('body').classList.toggle('no-scroll');
    }
    closeSubjectsNav();
  };

const addMainNavToggleHandlers = () => {

  const currentURL = window.location.href;

  if(currentURL.includes("how-use-esl")) {
    document.getElementsByClassName('esl')[0].classList.add('focus');
  }

  if(currentURL.includes("multi-factor-authentication")) {
    document.getElementsByClassName('mfa')[0].classList.add('focus');
  }

  if (document.getElementById('main-nav-burger') || document.getElementById('mobile-main-nav-burger')) {
    const el = document.getElementById('main-nav-burger');
    el.addEventListener('click', (e) => {
        toggleMobileMainNav();
    });
    const mobileEl = document.getElementById('mobile-main-nav-burger');
    mobileEl.addEventListener('click', (e) => {
        toggleMobileMainNav();
    });
  }
  const dropDownlinks = document.querySelectorAll('.js-toggle-focus.js-expanded');
  dropDownlinks.forEach((link) => {
    link.addEventListener('click', () => {
      closeSubjectsNav();
      collapseAllOtherExpandedDropdowns(link);
      link.classList.toggle('focus');
    });

    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        closeSubjectsNav();
        collapseAllOtherExpandedDropdowns(link);
        link.classList.toggle('focus');
      }
    });
  });
};

export const initMenuMain = () => {
    addMainNavToggleHandlers();
};

export default 'initMenuMain';